// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CopyTextDialog__CopyTextDialog___2j0su{width:100%}", ""]);
// Exports
exports.locals = {
	"CopyTextDialog": "CopyTextDialog__CopyTextDialog___2j0su"
};
module.exports = exports;
